var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div bb-event-groups>\n<div class=\"panel panel-default\" ng-repeat=\"item in items\">\n<div class=\"panel-body\">\n<h2 class=\"panel-title item-name\">\n{{item.name}}\n</h2>\n<div class=\"row\">\n<div class=\"col-sm-8 col-xs-9 item-description\">\n{{item.description}}\n</div>\n<div class=\"col-sm-2 col-xs-3 item-price\" ng-if=\"item.price\">\n<span class=\"currency-symbol\">£</span>{{item.price}}\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-2 col-sm-offset-10 service-select\">\n<button type=\"button\" ng-click=\"selectItem(item)\" class=\"btn btn-primary btn-block\" translate=\"PUBLIC_BOOKING.EVENT_GROUP_LIST.SELECT_BTN\">\n</button>\n</div>\n</div>\n</div>\n</div>\n</div>\n";
var id1="public-booking/_templates/steps/event_group_list.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/public-booking/_templates/steps/event_group_list.html
// module id = 1202
// module chunks = 0